/**
 * @module HojasGastoLin
 */
import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

const useFetchOptionsHojasGastoLin = () => {
  const [response, setResponse] = useState([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(() => {
    if (loading) {
      return
    }

    setLoading(true)
    axios
      .get(`/hojasgastolin/options`)
      .then((request_response) => {
        const data = request_response.data
        setResponse(data)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!loading) fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData])

  return { response, error, loading }
}

export default useFetchOptionsHojasGastoLin
